/* eslint-disable react/prop-types */
import { Link } from 'react-router-dom';
import styles from './single_card.module.scss';


const SingleCard = ({ title, img, url }) => {
	
	return (
		<Link
		to={url}
		className={styles.container_card}
		>
			<p className={styles.title_card}>{title}</p>
		</Link>
	);
};

export default SingleCard;
